import { DialogContent, Grid, FormControl } from "@mui/material";
import { DateRangePicker } from "rsuite";
import { Formik } from "formik";
import MDButton from "components/MDButton";
import MDDialog from "components/MDDialog";
import MDSnackbar from "components/MDSnackbar";
import moment from "moment-timezone";
import { useState } from "react";
import CircularIndeterminate from "components/MDLoading";
import { useMaterialUIController } from "context";
import { useDispatch } from "react-redux";
import { updateAssignRateDuration } from "store/slice/rates/rateSlice";
import { getCalenderDataByPlaceId } from "store/slice/rates/rateSlice";
import { getAssignRatesTableDataByPlaceId } from "store/slice/rates/rateSlice";

const UpdateAssignRateDialog = ({
  dialogOpen,
  onClose,
  rowData,
  type,
  placeId,
}) => {
  const dispatch = useDispatch();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({
    color: "",
    icon: "",
    title: "",
    content: "",
    show: false,
    close: () => setNotification((prev) => ({ ...prev, show: false })),
  });

  const handleSubmit = async (values) => {
    setIsLoading(true);
    const payload = {
      assignRateId: rowData?.assignRateId,
      ...(type === "assignRates"
        ? {
            startTime: moment(values.startTime).format("HH:mm"),
            endTime: moment(values.endTime).format("HH:mm"),
          }
        : {
            startDate: moment(values.startDate).toISOString(),
            endDate: moment(values.endDate).toISOString(),
          }),
    };
    await dispatch(updateAssignRateDuration(payload))
      .unwrap()
      .then(async (res) => {
        const success = res?.success;
        setIsLoading(false);
        setNotification({
          ...notification,
          color: success ? "success" : "error",
          title: success ? "Success" : "Error",
          content: res?.message,
          icon: success ? "check" : "warning",
          show: true,
        });
        if (success) {
          onClose();
          await dispatch(getCalenderDataByPlaceId(placeId));
          await dispatch(getAssignRatesTableDataByPlaceId(placeId));
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setNotification({
          ...notification,
          color: "error",
          title: "Error",
          content: err?.message,
          icon: "warning",
          show: true,
        });
      });
  };

  return (
    <>
      <CircularIndeterminate type="full" open={isLoading} text="Updating..." />

      <MDSnackbar
        {...notification}
        open={notification.show}
        close={notification.close}
        bgWhite
      />

      <MDDialog
        dialogTitle="Update Timing / Date"
        open={dialogOpen}
        dialogClose={onClose}
        closeIcon={true}
        maxWidth="sm"
      >
        <DialogContent>
          <Formik
            enableReinitialize
            initialValues={{
              startTime:
                type === "assignRates"
                  ? new Date(moment(rowData?.startTime, "HH:mm").toDate())
                  : new Date(rowData?.startDate),
              endTime:
                type === "assignRates"
                  ? new Date(moment(rowData?.endTime, "HH:mm").toDate())
                  : new Date(rowData?.endDate),

              startDate: new Date(rowData?.startDate),
              endDate: new Date(rowData?.endDate),
            }}
            onSubmit={handleSubmit}
          >
            {(props) => (
              <form onSubmit={props.handleSubmit}>
                <Grid container spacing={2} mt={1}>
                  {type === "assignRates" && (
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <DateRangePicker
                          placeholder="Start Time - End Time"
                          format="hh:mm a"
                          showMeridian
                          ranges={[]}
                          value={[
                            new Date(props.values.startTime),
                            new Date(props.values.endTime),
                          ]}
                          onChange={(value) => {
                            if (value?.length === 2) {
                              props.setFieldValue("startTime", value[0]);
                              props.setFieldValue("endTime", value[1]);
                            }
                          }}
                        />
                      </FormControl>
                    </Grid>
                  )}

                  {type !== "assignRates" && (
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <DateRangePicker
                          placeholder="Start Date - End Date"
                          format="dd/MM/yyyy hh:mm aa"
                          showMeridian
                          ranges={[]}
                          value={[
                            new Date(props.values.startDate),
                            new Date(props.values.endDate),
                          ]}
                          onChange={(value) => {
                            if (value?.length === 2) {
                              props.setFieldValue("startDate", value[0]);
                              props.setFieldValue("endDate", value[1]);
                            }
                          }}
                        />
                      </FormControl>
                    </Grid>
                  )}

                  <Grid item xs={12} textAlign="right">
                    <MDButton
                      variant="contained"
                      size="small"
                      onClick={onClose}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      color={sidenavColor}
                      variant="contained"
                      type="submit"
                      size="small"
                    >
                      Confirm
                    </MDButton>
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </DialogContent>
      </MDDialog>
    </>
  );
};

export default UpdateAssignRateDialog;
